define('viewmodels/pages/cash/history/bets',['knockout', 'underscore', 'moment'], function (ko, _, moment) {

    var BetsListViewModel = function(gameRoundsService, getField) {
        var self = this;

        self.activate = function() {
            self.getGameRounds();
        };

        self.fields = {
            from: getField('time_picker_from'),
            to: getField('time_picker_to'),
            time: getField('table_time'),
            bet: getField('table_bet'),
            win: getField('table_win'),
            balance: getField('table_balance'),
            noResultsLabel: getField('empty_results_label'),
            loadMoreButton: getField('load_more_button'),
            loadingLabel: getField('loading_label'),
            freeSpinsText: getField('free_spins_text'),
            seeHistory: getField('see_history_button')
        };

        self.minimizedPage = ko.observable(false);
        self.gameRounds = ko.observableArray();
        self.gameRoundTables = ko.observableArray();
        self.betsFrom = ko.observable(moment().subtract(1,'d').format('YYYY-MM-DDTHH:mm'));
        self.betsTo =  ko.observable(moment().add(1,'m').format('YYYY-MM-DDTHH:mm'));
        self.nextSequenceNumber = ko.observable();
        self.isLoading = ko.observable(false);

        self.getGameRounds = function() {
            self.gameRounds([]);
            self.isLoading(true);

            gameRoundsService.get(self.betsFrom(), self.betsTo(), null).then(function (response) {
                self.gameRounds(response.gameRounds);
                self.nextSequenceNumber(response.nextSequenceNumber);
                createGameRoundTables();
                self.isLoading(false);
            });
        };

        self.getMoreGameRounds = function() {
            if (!self.nextSequenceNumber()) {
                return;
            }

            self.isLoading(true);

            gameRoundsService.get(self.betsFrom(), self.betsTo(), self.nextSequenceNumber()).then(function (response) {
                _.forEach(response.gameRounds, function(round) {
                    self.gameRounds.push(round);
                });

                self.nextSequenceNumber(response.nextSequenceNumber);
                createGameRoundTables();
                self.isLoading(false);
            });
        };

        var getGameText = function (gameRound) {
            if (gameRound.gameName()) {
                return gameRound.gameName;
            }

            var parts = [];

            if (!gameRound.betAmount) {
                parts.push(self.fields.freeSpinsText());
            }

            if (gameRound.gameProviderName()) {
                parts.push('[' + gameRound.gameProviderName() + ']');
            }

            return parts.join(' ');
        };

        var createGameRoundTables = function() {
            var prevRoundGameName = null;
            var tableArray = [];
            self.gameRoundTables([]);

            _.forEach(self.gameRounds(), function(gameRound) {
                var unwrappedGameName;

                gameRound.gameName = getGameText(gameRound);
                unwrappedGameName = ko.unwrap(gameRound.gameName);

                if(unwrappedGameName !== prevRoundGameName) {
                        tableArray.push([gameRound]);
                } else {
                    _.last(tableArray).push(gameRound);
                }

                prevRoundGameName = unwrappedGameName;
            });

            _.forEach(tableArray, function(table) {
              self.gameRoundTables.push(table);
            });

        }
    };

    return BetsListViewModel;
});


